import { Duplexer, Channel, VirtualSocket, InstanceUpdater } from '@wix/duplexer-js';
import { assertString } from './invariants';

export class DuplexerEvent<Payload = unknown> {
  private readonly duplexer: Duplexer;
  private subscription?: Channel;
  private connection?: VirtualSocket;

  constructor(private readonly channel: string, private readonly event: string, private readonly appDefId: string) {
    this.duplexer = new Duplexer('duplexer.wix.com', { instanceUpdater: this.getInstanceUpdater() });
  }

  private getInstanceUpdater = (): InstanceUpdater => {
    return {
      getInstance: () => {
        assertString(window.__SIGNED_INSTANCE__);
        return window.__SIGNED_INSTANCE__;
      },
    };
  };

  unsubscribe(): void {
    this.subscription?.off(this.event);
    this.connection?.disconnect();
    this.duplexer.close();
  }

  subscribe(callback: (payload: Payload) => void): () => void {
    if (!this.subscription) {
      this.connection = this.duplexer.connect({ appDefId: this.appDefId });
      this.subscription = this.connection.subscribe(this.channel);

      this.subscription.on(this.event, (payload: Payload) => {
        callback(payload);
      });
    }

    return this.unsubscribe;
  }
}
